<p>detail-actes-bareme works!</p>
